module.exports = __webpack_public_path__ + "img/nakladki-na-pedaly-matowane-aluminium.29359f5b.jpg";